import React, {useEffect, useState} from 'react';
import styles from './MatchesTable.module.css';
import {
    renderMatchResult,
    checkIfResultsEntered,
    renderPlayerName,
    renderPartnerName,
} from "../../../utils";
import {getUserData} from "../../../api/api";

const MatchesTable = ({matches, onEditMatch, isArchived, isFinal, onOpenH2H}) => {
    const [userData, setUserData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const data = await getUserData();
            setUserData(data);
        };
        fetchData();
    }, []);

    const canUserEditMatch = (match) => {
        const userRoles = new Set(userData.authorities || []);
        const isUserAdminOrViewer = userRoles.has("ROLE_ADMIN") || userRoles.has("ROLE_SUPERVISOR");
        const isUserParticipant = match.userId1 === userData.id || match.userId2 === userData.id || match.userId1Partner === userData.id || match.userId2Partner === userData.id;

        return isUserAdminOrViewer || isUserParticipant;
    };


    const matchesByRound = matches.reduce((acc, match) => {
        const round = match.roundNumber || 1;
        if (!acc[round]) acc[round] = [];
        acc[round].push(match);
        return acc;
    }, {});

    const totalMatches = matches.length;
    const playedMatches = matches.filter(match => match.participantWinnerId !== null).length;
    const progressPercentage = totalMatches > 0 ? Math.round((playedMatches / totalMatches) * 100) : 0;

    const getProgressColor = (percentage) => {
        if (percentage === 100) return '#2196f3';
        if (percentage >= 67) return '#4caf50';
        if (percentage >= 34) return '#ffeb3b';
        return '#f44336';
    };


    return (
        <div className={styles.container}>
            <h5 className={styles.title}>Mecze</h5>


            {!isArchived && (
                <div className={styles.progressWrapper}>
                    <div className={styles.progressBar}>
                        <div
                            className={styles.progressFill}
                            style={{
                                width: `${progressPercentage}%`,
                                backgroundColor: getProgressColor(progressPercentage),
                            }}
                        ></div>
                    </div>
                    <div className={styles.progressText}>{progressPercentage} % rozegranych ({playedMatches}/{totalMatches})</div>
                </div>
            )}

            <div className={styles.gridContainer}>
                {Object.keys(matchesByRound)
                    .sort((a, b) => a - b)
                    .flatMap(round => {
                        const showHeader = Object.keys(matchesByRound).length > 1;
                        return matchesByRound[round].map((match, index) => (
                            <div key={match.id} className={styles.card}>
                                {showHeader && (
                                    <div className={styles.roundHeader}>Runda {round}</div>
                                )}
                                <div className={styles.cardHeader}>
                                    <span>{index + 1}</span>
                                    <div className={styles.actions}>
                                        {!isArchived && !isFinal && !checkIfResultsEntered(match) && (
                                            <button
                                                className={styles.button}
                                                onClick={() => onOpenH2H && onOpenH2H(match.id)}
                                            >
                                                H2H
                                            </button>
                                        )}

                                        {!isArchived && canUserEditMatch(match) && !isFinal && (
                                            <button className={styles.button} onClick={() => onEditMatch(match.id)}>
                                                {checkIfResultsEntered(match) ? 'Edytuj' : 'Dodaj'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.result}>
                                    <div className={styles.playerNames}>
                                        <div>
                                            {renderPlayerName(match.participant1Id, match.participant1LastName, match.participant1FirstName, match)}
                                            {match.participant1PartnerLastName && (
                                                <>
                                                    <br />
                                                    <span className={styles.partnerName}>
                      {renderPartnerName(match.participant1Id, match.participant1PartnerLastName, match.participant1PartnerFirstName, match)}
                    </span>
                                                </>
                                            )}
                                        </div>
                                        <div>
                                            {renderPlayerName(match.participant2Id, match.participant2LastName, match.participant2FirstName, match)}
                                            {match.participant2PartnerLastName && (
                                                <>
                                                    <br />
                                                    <span className={styles.partnerName}>
                      {renderPartnerName(match.participant2Id, match.participant2PartnerLastName, match.participant2PartnerFirstName, match)}
                    </span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        {match.setResults && renderMatchResult(match.setResults)}
                                    </div>
                                </div>
                            </div>
                        ));
                    })}
            </div>
        </div>
    );
};

export default MatchesTable;
